// Utilitário único de máscara e validação de CPF.
export const cleanCpf = (value: string): string =>
    (value ?? "").toString().replace(/\D/g, "");

export const maskCpf = (value: string): string => {
    let v = cleanCpf(value).slice(0, 11);

    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return v;
};

// Nome mantido por compatibilidade com o restante do projeto (formatação de exibição).
export const formatarCPF = maskCpf;

export const isValidCpf = (value: string): boolean => {
    const cpf = cleanCpf(value);

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let sum = 0;
    for (let i = 1; i <= 9; i++) sum += parseInt(cpf.charAt(i - 1)) * (11 - i);
    let rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.charAt(9))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) sum += parseInt(cpf.charAt(i - 1)) * (12 - i);
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.charAt(10))) return false;

    return true;
};
